import root from 'window-or-global';

export default () => {
  return !!root.includeExternal;
};
